import { useEffect } from "react";
import "./HyperBeamAnimation.css";

export default function HyperBeamAnimation({ playerRef, opponentRef, onComplete }) {

  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.closest(".battle-bg");
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const startX = (pRect.left + pRect.width / 2) - cRect.left;
    const startY = (pRect.top + pRect.height / 2) - cRect.top;
    const endX = (oRect.left + oRect.width / 2) - cRect.left;
    const endY = (oRect.top + oRect.height / 2) - cRect.top;

    // Calculate angle and distance
    const dx = endX - startX;
    const dy = endY - startY;
    const angle = Math.atan2(dy, dx);
    const distance = Math.sqrt(dx * dx + dy * dy);

    const elements = [];

    // Phase 1: Charging effect on attacker
    const chargeEffect = document.createElement("div");
    chargeEffect.className = "hyper-beam-charge";
    chargeEffect.style.left = `${startX}px`;
    chargeEffect.style.top = `${startY}px`;
    container.appendChild(chargeEffect);
    elements.push(chargeEffect);


    // Attacker charging animation
    if (playerEl) {
      playerEl.classList.add("hyper-beam-charging");
    }

    // Phase 2: Main beam after charging (1.5s delay)
    setTimeout(() => {
      // Create main beam
      const beam = document.createElement("div");
      beam.className = "hyper-beam-main";
      beam.style.left = `${startX}px`;
      beam.style.top = `${startY}px`;
      beam.style.width = `${distance}px`;
      beam.style.transform = `translate(-50%, -50%) rotate(${angle}rad)`;
      beam.style.transformOrigin = "0 50%";
      container.appendChild(beam);
      elements.push(beam);


      // Create energy ripples along the beam
      for (let i = 0; i < 8; i++) {
        const ripple = document.createElement("div");
        ripple.className = "hyper-beam-ripple";
        const progress = i / 8;
        const rippleX = startX + dx * progress;
        const rippleY = startY + dy * progress;
        
        ripple.style.left = `${rippleX}px`;
        ripple.style.top = `${rippleY}px`;
        ripple.style.animationDelay = `${i * 0.1}s`;
        
        container.appendChild(ripple);
        elements.push(ripple);
      }

      // Remove charging effects
      chargeEffect.remove();
      if (playerEl) {
        playerEl.classList.remove("hyper-beam-charging");
        playerEl.classList.add("hyper-beam-firing");
      }
    }, 1500);

    // Phase 3: Impact effect (2.0s delay)
    setTimeout(() => {
      if (opponentEl) {
        opponentEl.classList.add("hyper-beam-hit");
      }

      // Create massive impact explosion
      const explosion = document.createElement("div");
      explosion.className = "hyper-beam-explosion";
      explosion.style.left = `${endX}px`;
      explosion.style.top = `${endY}px`;
      container.appendChild(explosion);
      elements.push(explosion);

      // Create shockwave rings
      for (let i = 0; i < 3; i++) {
        const shockwave = document.createElement("div");
        shockwave.className = "hyper-beam-shockwave";
        shockwave.style.left = `${endX}px`;
        shockwave.style.top = `${endY}px`;
        shockwave.style.animationDelay = `${i * 0.2}s`;
        
        container.appendChild(shockwave);
        elements.push(shockwave);
      }

    }, 2000);

    // Phase 4: Cleanup and complete (4.0s total)
    setTimeout(() => {
      elements.forEach(el => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      
      if (playerEl) {
        playerEl.classList.remove("hyper-beam-firing");
      }
      if (opponentEl) {
        opponentEl.classList.remove("hyper-beam-hit");
      }
      
      onComplete();
    }, 4000);

    return () => {
      elements.forEach(el => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      if (playerEl) {
        playerEl.classList.remove("hyper-beam-charging", "hyper-beam-firing");
      }
      if (opponentEl) {
        opponentEl.classList.remove("hyper-beam-hit");
      }
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

HyperBeamAnimation.moveType = "normal";
